import { create as createFedopsLogger, FedopsLogger } from '@wix/fedops-logger'
import { tryCatch } from '@wix/funnel-utils'

const usePanorama = window.__USE_PANORAMA__ === 'true'

let logger: FedopsLogger

if (usePanorama) {
  const { panoramaClient } = require('./panorama') as typeof import('./panorama')
  panoramaClient.reportLoadStart()
  logger = {
    appLoaded: () => panoramaClient.reportLoadFinish(),
    interactionStarted: (name: string) => panoramaClient.transaction(name).start(),
    interactionEnded: (name: string) => panoramaClient.transaction(name).finish(),
    getReporter: () => ({ _publisher: { flush: () => Promise.resolve() } }),
  } as unknown as FedopsLogger
} else {
  logger = createFedopsLogger('funnel-intro-viewer')
  window.addEventListener('beforeunload', async () => {
    await flushFedops()
  })
}

export const flushFedops = async () => {
  // Undocumented API that allows await-ing for fedops events to be sent
  // fedopsLogger also has method .flush() that calls this, but doesn't return result and doesn't await it
  // https://github.com/wix-private/fedops/blob/e5b1b1cf6e4910767a0b61bb4420da63151bbd28/packages/fedops-logger/src/reporter/reporter.js#L20
  const reporter = logger.getReporter() as any
  await tryCatch(() => reporter?._publisher?.flush())
}

export const fedopsLogger = logger
